import * as React from "react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
export const DropdownFilterCell = (props) => {
  let hasValue = (value) => Boolean(value && value !== props.defaultItem);
  const onChange = (event) => {
    hasValue = hasValue(event.target.value);
    props.onChange({
      value: hasValue ? event.target.value.id : "",
      operator: hasValue ? "eq" : "",
      syntheticEvent: event.syntheticEvent,
    });
  };
  const onClearButtonClick = (event) => {
    event.preventDefault();
    props.onChange({
      value: "",
      operator: "",
      syntheticEvent: event,
    });
  };
  return (
    <div
      className="k-filtercell bg-black space-x-1"
      style={{ backgroundColor: "transparent", color: "#b9b9b9" }}
      id="userrolecompo"
    >
      <DropDownList
        data={props.data}
        onChange={onChange}
        textField="name"
        dataItemKey="id"
        style={{
          borderColor: "transparent",
          backgroundColor: "transparent",
          color: "#b9b9b9",
        }}
        value={
          props.data.find((x) => x.id === props.value) || props.defaultItem
        }
        // defaultItem={props.defaultItem}
      />
      <Button
        title="Clear"
        disabled={!hasValue(props.value)}
        onClick={onClearButtonClick}
        icon="filter-clear"
      />
    </div>
  );
};
